<label *ngIf="labelInfo | async">{{ labelInfo | async }}</label>
<input type="range" [min]="minStep" [max]="maxStep" step="1" class="form-control range-velocity" container="body" [value]="progress | async">
<div class="col btn-group group-velocity">
    <button class="btn btn-sm" tooltip="Parar Animação"
        (click)="stop()">
        <i class="fa fa-stop"></i>
    </button>
    <button class="btn btn-sm" tooltip="Ir para o Primeiro"
        (click)="toFirst()">
        <i class="fa fa-step-backward"></i>
    </button>
    <button class="btn btn-sm" tooltip="Ir para o Anterior"
        (click)="toPrevious()">
        <i class="fa fa-chevron-left"></i>
    </button>
    <button class="btn btn-sm" [tooltip]="isAnimating ? 'Pausar Animação' : 'Iniciar Animação'"
        (click)="toggleAnimation()">
        <i class="fa" [class.fa-play]="!isAnimating" [class.fa-pause]="isAnimating"></i>
    </button>
    <button class="btn btn-sm" tooltip="Ir para o Próximo" (click)="toNext()">
        <i class="fa fa-chevron-right"></i>
    </button>
    <button class="btn btn-sm" tooltip="Ir para o Último" (click)="toLast()">
        <i class="fa fa-step-forward"></i>
    </button>
    <button class="btn btn-sm btn-velocity" tooltip="Clique para alterar a velocidade da animação" (click)="onChangeVelocity()">
        {{velocity}}x
    </button>
</div>
